import React from 'react';
import Navbar from '../components/Navbar';

export default function StatutoPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-20 p-6 max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Statuto</h1>
        </div>

        <div className="mb-8">
          <div className="text-gray-700 leading-relaxed whitespace-pre-wrap statuto-content">
            <section>
              <h2><strong>Articolo 1 – Denominazione e Sede</strong></h2>
              <p><strong>1.1</strong> L’associazione non riconosciuta assume la denominazione di “Base”.</p>
              <p><strong>1.2</strong> La sede legale dell’Associazione è stabilita in Roma.</p>
              <p><strong>1.3</strong> Base potrà istituire sezioni o rappresentanze in altre località, previa delibera del Consiglio Direttivo.</p>
            </section>

            <section>
              <h2><strong>Articolo 2 – Scopo</strong></h2>
              <p><strong>2.1</strong> L’Associazione Base ha come scopo la nascita e lo sviluppo di relazioni tra professionisti di alto profilo e giovani talenti, promuovendo connessioni amichevoli e professionali che generino valore per i suoi soci e impatto per la comunità.</p>
              <p><strong>2.2</strong> L’Associazione promuove la crescita professionale, la formazione, l’impegno civile e la responsabilità sociale dei propri associati. Nell’adempimento dei propri compiti e nel raggiungimento dei propri scopi, fa propri i valori della Repubblica Italiana e dell’Unione Europea.</p>
              <p><strong>2.3</strong> Al fine di diffondere e proteggere i valori che essa persegue, l’Associazione svolge qualsiasi attività lecita ritenuta utile per gli associati e per la comunità, attraverso eventi, discussioni, dibattiti e rassegne.</p>
            </section>

            <section>
              <h2><strong>Articolo 3 – Durata</strong></h2>
              <p><strong>3.1</strong> L’Associazione è costituita a tempo indeterminato.</p>
            </section>

            <section>
              <h2><strong>Articolo 4 – Struttura Organizzativa</strong></h2>

              <p><strong>4.1</strong> Base si avvale di una struttura organizzativa composta dai seguenti organi: Assemblea dei soci; Collegio dei Fondatori; Presidente; Consiglio Direttivo; Advisory Board; eventuali Comitati Tecnici costituiti dal Consiglio Direttivo.</p>

              <div>
                <p><strong>4.2</strong> Assemblea: è l’organo collegiale dell’Associazione con funzione deliberante ed è composta da tutti i soci in regola con il pagamento della quota associativa. Ogni socio ha diritto ad un voto nelle deliberazioni assembleari.</p>
                <ul>
                  <li>Si riunisce almeno una volta all’anno, per l’approvazione del bilancio.</li>
                  <li>Elege il Presidente e approva la composizione del Consiglio Direttivo.</li>
                  <li>È competente per l’approvazione delle modifiche dell’atto costitutivo e dello statuto dell’Associazione.</li>
                  <li>Delibera su tutte le altre questioni che le siano sottoposte dal Consiglio Direttivo.</li>
                  <li>Le deliberazioni assembleari sono efficaci solo se tengono conto del parere espresso dal Collegio dei Fondatori.</li>
                </ul>
              </div>

              <div>
                <p><strong>4.3</strong> Collegio dei Fondatori: organo permanente di garanzia, composto da tutti i soci fondatori (art. 5.3). Lo status di componente è personale, permanente e intrasmissibile.</p>
                <p>Il Collegio esprime parere vincolante su:</p>
                <ul>
                  <li>nomina e revoca del Presidente e dei membri del Consiglio Direttivo;</li>
                  <li>approvazione del bilancio d’esercizio;</li>
                  <li>modifiche dell’Atto Costitutivo, dello Statuto e del Regolamento Interno;</li>
                  <li>scioglimento anticipato dell’Associazione e destinazione del patrimonio;</li>
                  <li>ogni altra deliberazione che il Consiglio Direttivo ritenga di sottoporgli.</li>
                </ul>
                <p>In assenza di detto parere, la deliberazione assembleare o consiliare è inefficace.</p>
                <p>Il Collegio può inoltre dirimere, con decisione motivata presa a maggioranza dei presenti, controversie tra soci o tra soci e organi sociali, ex bono et aequo e senza formalità.</p>
              </div>

              <div>
                <p><strong>4.4</strong> Presidente: rappresenta l’associazione; ne è responsabile, ne dirige le attività e convoca gli organi sociali. È eletto dall’Assemblea dei membri per un triennio, previa approvazione del Collegio dei Fondatori.</p>
                <ul>
                  <li>Propone i membri del Consiglio Direttivo all’Assemblea, che ne approva la composizione.</li>
                  <li>È facoltà del Presidente nominare, senza formalità, un Vicepresidente tra i membri del Consiglio Direttivo.</li>
                  <li>Cessato dalla carica, il Presidente è rieleggibile.</li>
                </ul>
              </div>

              <div>
                <p><strong>4.5</strong> Consiglio Direttivo: organo di gestione, composto dal Presidente e da un numero variabile di consiglieri eletti dall’Assemblea su proposta del Presidente e con parere favorevole del Collegio dei Fondatori.</p>
                <p>È responsabile dell’amministrazione, della gestione finanziaria e dell’esecuzione delle deliberazioni assembleari.</p>
              </div>

              <div>
                <p><strong>4.6</strong> Advisory Board: organo consultivo istituito dal Consiglio Direttivo e composto da esperti di alto profilo nei settori di interesse di BASE, con incarico triennale tacitamente rinnovabile salvo revoca.</p>
              </div>

              <p><strong>4.7</strong> Il Consiglio Direttivo può istituire, con propria delibera, comitati per finalità specifiche e speciali incarichi, determinandone composizione e durata.</p>
            </section>

            <section>
              <h2><strong>Articolo 5 – Associati</strong></h2>

              <p><strong>5.1</strong> Possono far parte di Base professionisti di alto profilo e giovani talenti che abbiano ricevuto un invito da parte dell’Associazione o abbiano presentato domanda di ammissione nelle forme previste dal Regolamento approvato dal Consiglio Direttivo. L’ammissione dei membri è fondata su criteri quali l’eccellenza professionale, l’esperienza e la motivazione ad apportare un contributo all’Associazione, il decoro personale e la condotta dignitosa.</p>

              <p><strong>5.1 bis</strong> Sono ammessi a partecipare all’Associazione persone giuridiche.</p>

              <p><strong>5.2</strong> Ogni nuovo socio ordinario è ammesso con un periodo di prova di sei mesi, durante il quale gode dei medesimi diritti e doveri ad eccezione: a) del diritto di voto in Assemblea; b) dell’obbligo di versare la quota associativa. Decorso il periodo senza opposizioni, l’ammissione diviene definitiva.</p>

              <div>
                <p><strong>5.3</strong> I soci si distinguono in: fondatori; ordinari; onorari; benemeriti. Tutti i soci condividono pari diritti e doveri, salvo quanto previsto per i fondatori ai fini della governance.</p>
                <ul>
                  <li>soci fondatori: la qualifica spetta esclusivamente ai firmatari dell’Atto Costitutivo e a coloro a cui sia conferita successivamente con delibera unanime dei fondatori esistenti. Lo status è personale, permanente, intrasmissibile e non revocabile, salvo indegnità accertata;</li>
                  <li>soci ordinari: ammessi attraverso il procedimento di ammissione disciplinato dallo Statuto e della procedura dedicata;</li>
                  <li>soci onorari: conferiti dall’Assemblea, su proposta del Consiglio Direttivo, in riconoscimento di particolari meriti culturali o professionali;</li>
                  <li>soci benemeriti: attribuiti dall’Assemblea, su proposta del Consiglio Direttivo, a soggetti che abbiano fornito contributi economici rilevanti a sostegno delle finalità associative.</li>
                </ul>
              </div>

              <p><strong>5.4</strong> I membri contribuiscono con una quota associativa annuale, la cui entità è stabilita con delibera del Consiglio Direttivo. Il pagamento della quota associativa è requisito per il mantenimento della qualifica di socio. Il versamento della quota deve avvenire entro il 31 Dicembre di ogni anno.</p>

              <p><strong>5.5</strong> Nel rispetto dei valori dell’Associazione e delle norme statutarie sulla riservatezza delle attività di Base, possono essere invitati a partecipare a singole attività o essere informati sulle iniziative dell’Associazione soggetti terzi, che non assumono lo status di socio.</p>

              <p><strong>5.6</strong> Ciascun socio può in ogni momento recedere dall’Associazione, dandone comunicazione motivata per iscritto al Consiglio Direttivo, con un preavviso minimo di 30 giorni.</p>

              <p><strong>5.7</strong> Il socio può recedere con preavviso scritto di almeno 30 giorni al Consiglio Direttivo. L’esclusione per gravi motivi è deliberata dall’Assemblea; per i fondatori l’esclusione richiede la previa decisione unanime degli altri fondatori.</p>
            </section>

            <section>
              <h2><strong>Articolo 6 – Risorse Finanziarie</strong></h2>

              <div>
                <p><strong>6.1</strong> Il patrimonio dell’Associazione è costituito:</p>
                <ul>
                  <li>dalle quote associative versate dai soci;</li>
                  <li>da sponsorizzazioni, sovvenzioni e contributi di enti pubblici e privati; donazioni e lasciti che essa può ricevere;</li>
                  <li>da eventuali ricavi derivanti da progetti e attività promosse da Base.</li>
                </ul>
              </div>

              <p><strong>6.2</strong> Con delibera del Consiglio direttivo è istituito un comitato per la gestione finanziaria dell’Associazione. Il comitato è presieduto dal Presidente dell’Associazione ed un socio assume le funzioni di Tesoriere. Il Tesoriere rimane in carica fintantoché è in carica il Presidente e il Consiglio Direttivo. Le funzioni del Tesoriere sono prorogate fino alla nomina del suo sostituto, a meno che l’Assemblea non ne deliberi la sospensione per gravi motivi. Se il comitato non è costituito, le relative competenze spettano al Consiglio Direttivo.</p>

              <p><strong>6.3</strong> Le modalità di pagamento della quota, la sua misura e il termine per il suo versamento sono stabilite con delibera del Consiglio Direttivo.</p>

              <p><strong>6.4</strong> Non è ammessa la distribuzione tra gli associati degli utili dell’Associazione, neanche in via indiretta.</p>
            </section>

            <section>
              <h2><strong>Articolo 7 – Regolamento Interno</strong></h2>

              <div>
                <p><strong>7.1</strong> L’Associazione adotta un Regolamento Interno che definisce modalità e aspetti operativi e organizzativi. Il Regolamento Interno include, tra gli altri, i seguenti punti:</p>
                <ul>
                  <li>La procedura per l’ammissione degli associati, compresi i criteri di valutazione e i requisiti richiesti.</li>
                  <li>La procedura per la predisposizione, gestione e consultazione di una database interno dei membri al fine di facilitare l’interazione, la condivisione di informazioni e la creazione di connessioni tra i membri.</li>
                </ul>
              </div>

              <p><strong>7.2</strong> Il primo Regolamento Interno è adottato con delibera del Consiglio Direttivo e sottoposto, per l’approvazione, all’Assemblea. È facoltà del Consiglio Direttivo modificare il Regolamento interno, salva la ratifica da parte della prima Assemblea convocata. Le modifica non ancora ratificate sono provvisoriamente efficaci.</p>
            </section>

            <section>
              <h2><strong>Articolo 8 – Riservatezza e Non Pubblicità</strong></h2>
              <p><strong>8.1</strong> Base garantisce la massima riservatezza nei confronti dei suoi soci ed ospiti e si impegna a proteggere le informazioni personali e professionali nel rispetto delle leggi sulla privacy.</p>
              <p><strong>8.2</strong> I soci sono tenuti a rispettare la riservatezza delle informazioni scambiate all’interno dell’Associazione e a non divulgarle a terzi senza il consenso esplicito dei diretti interessati.</p>
              <p><strong>8.3</strong> Base non farà uso pubblico dei nominativi dei suoi membri, né divulgherà informazioni sulle attività e i progetti dell’associazione all’esterno, a meno che non vi sia stato un consenso specifico da parte dei soci coinvolti.</p>
            </section>

            <section>
              <h2><strong>Articolo 9 – Modifiche dello Statuto</strong></h2>
              <p><strong>9.1</strong> Il presente Statuto potrà essere modificato su proposta del Consiglio Direttivo o della maggioranza assoluta dei membri di Base. Ciascun socio può sottoporre nuove proposte di modifica dello Statuto o dell’Atto costitutivo al Consiglio Direttivo, che ne assume l’iniziativa.</p>
              <p><strong>9.2</strong> Le proposte di modifica possono essere oggetto di veto da parte del Collegio dei Fondatori.</p>
            </section>

            <section>
              <h2><strong>Articolo 10 – Norme Applicabili</strong></h2>
              <p><strong>10.1</strong> Per tutto quanto non previsto nel presente documento costitutivo e nel Regolamento Interno, si applicano le norme del Codice civile e alle disposizioni di legge vigenti in materia di associazioni non riconosciute.</p>
            </section>

            <h2 className="text-3xl font-bold text-gray-900 mb-4">Codice Etico</h2>

            <section>
              <h2><strong>Introduzione</strong></h2>
              <p>
                Il presente Codice Etico stabilisce i principi e i valori che guidano l’operato dei soci di Base.
                È fondamentale che ogni associato si attenga a tali princìpi al fine di creare un ambiente di collaborazione,
                rispetto reciproco e professionalità all’interno dell’Associazione.
              </p>
            </section>

            <section>
              <h2><strong>Integrità e Professionalità</strong></h2>
              <p>
                I soci di Base si impegnano a condurre le proprie attività professionali con integrità e professionalità,
                nel rispetto delle norme etiche e dei princìpi deontologici della propria professione.
              </p>
              <p>
                I soci evitano comportamenti fraudolenti, sleali o scorretti che possano danneggiare l’immagine di Base
                o dei colleghi.
              </p>
              <p>
                Per il perseguimento di fini di alto valore, i soci devono mantenere una condotta, anche privata,
                decorosa e degna.
              </p>
            </section>

            <section>
              <h2><strong>Rispetto e Diversità</strong></h2>
              <p>
                In Base è promosso un ambiente inclusivo e rispettoso, nel quale ogni associato è valorizzato per le proprie
                competenze, senza alcuna forma di discriminazione basata su sesso, razza, etnia, religione, orientamento sessuale,
                disabilità o qualsiasi altra caratteristica personale.
              </p>
              <p>
                I soci si impegnano a trattare gli altri soci con rispetto, cortesia e collaborazione, favorendo un clima
                di fiducia reciproca.
              </p>
            </section>

            <section>
              <h2><strong>Riservatezza e Rispetto della Privacy</strong></h2>
              <p>
                I soci di Base si impegnano a mantenere la massima riservatezza sulle informazioni scambiate all’interno
                dell’Associazione e a proteggere la privacy dei colleghi.
              </p>
              <p>
                Le informazioni confidenziali o riservate acquisite in occasione delle attività di Base non devono essere divulgate
                né utilizzate a fini personali senza il consenso esplicito dei diretti interessati.
              </p>
            </section>

            <section>
              <h2><strong>Collaborazione e Condivisione</strong></h2>
              <p>
                In Base sono promosse la collaborazione e lo scambio di conoscenze ed esperienze tra i soci.
                Ciascun socio si impegna a condividere informazioni, best practice e opportunità professionali,
                nel rispetto degli interessi e dei diritti degli altri soci.
              </p>
            </section>

            <section>
              <h2><strong>Impegno verso la Comunità</strong></h2>
              <p>
                L’Associazione sostiene l’impegno dei propri soci verso la comunità e la generazione di impatto sociale positivo.
                I soci sono invitati a contribuire al progresso e al benessere delle comunità di riferimento attraverso iniziative
                di volontariato, divulgazione di conoscenze o altre attività a fini sociali.
              </p>
            </section>

            <section>
              <h2><strong>Conformità alle Leggi e Normative</strong></h2>
              <p>
                I soci si impegnano a rispettare le leggi, i regolamenti e le normative applicabili nell’esercizio delle proprie
                attività professionali.
              </p>
              <p>
                È responsabilità dei soci informarsi sulle norme applicabili all’attività associativa e assicurarsi di operare
                nel rispetto delle stesse.
              </p>
            </section>

            <section>
              <h2><strong>Responsabilità verso Base</strong></h2>
              <p>
                I soci si impegnano a sostenere gli obiettivi e i valori dell’Associazione, contribuendo attivamente alle attività,
                al networking e alla crescita dell’Associazione stessa.
              </p>
              <p>
                I soci si impegnano inoltre a fornire informazioni veritiere e complete sulla propria qualifica professionale
                e sull’esperienza lavorativa, contribuendo così al successo collettivo dell’Associazione.
              </p>
            </section>

            <section>
              <h2><strong>Violazioni del Codice Etico</strong></h2>
              <p>
                Eventuali violazioni del presente Codice Etico saranno esaminate dal Consiglio Direttivo, che prenderà in
                considerazione le misure disciplinari appropriate.
              </p>
              <p>
                Le sanzioni per le violazioni potranno includere richiami formali, sospensione temporanea dei diritti associativi
                o l’esclusione definitiva da Base, a seconda della gravità della violazione.
              </p>
            </section>
          </div>
        </div>
      </div>

      <footer className="bg-white border-t border-gray-200 py-8 px-4 mt-12">
        <div className="container mx-auto text-center text-gray-600">
          <p>© {new Date().getFullYear()} BASE. Tutti i diritti riservati.</p>
        </div>
      </footer>
    </div>
  );
}
